import { defineComponent as _defineComponent } from 'vue';
import { useActions, useGetters, useState } from "vuex-composition-helpers";
import { useRoute } from "vue-router/composables";
import moment from 'moment';
import { computed, onMounted, ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'QueueList',
    setup(__props) {
        const headers = [
            {
                text: "Date time",
                align: "start",
                value: "createdAt",
                width: '20%'
            },
            {
                text: "Feed",
                align: "start",
                value: "feed",
            },
            {
                text: "Task",
                align: "start",
                value: "task",
            },
            {
                text: "State",
                align: "start",
                value: "state",
            },
        ];
        function formatDate(date) {
            return moment(date).format('MMM D YYYY, h:mm:ss a');
        }
        const feedId = useRoute().params.id;
        const page = ref(1);
        const perPage = ref(10);
        const sortBy = ref(null);
        const sortDesc = ref(false);
        const queryParams = computed(() => {
            const baseQuery = {
                $limit: perPage.value,
                $sort: {
                    createdAt: -1
                },
                $skip: (page.value - 1) * perPage.value
            };
            if (sortBy.value !== null) {
                // @ts-ignore
                baseQuery.$sort = { [sortBy.value]: sortDesc.value ? -1 : 1 };
            }
            if (feedId)
                baseQuery.feedId = feedId;
            return baseQuery;
        });
        const { find: fetchQueueStats } = useActions('queue-management', ['find']);
        const totalItems = ref(0);
        watch(queryParams, () => fetchQueueStats({ query: queryParams.value }).then((res) => totalItems.value = res.total), { immediate: true });
        onMounted(() => fetchQueueStats({ query: { state: 'pending', $limit: 1 }, qid: 'pendings' }));
        const { isFindPending: areQueuesLoading } = useState('queue-management', ['isFindPending']);
        const { find: findQueuesFromStore } = useGetters('queue-management', ['find']);
        const queues = computed(() => {
            return findQueuesFromStore.value({ query: queryParams.value }).data;
        });
        const store = useState('queue-management', ['pagination']);
        const pendingQueuesCount = computed(() => {
            //console.log(store.pagination?.value);
            // @ts-ignore
            return store.pagination?.value?.pendings?.mostRecent?.total;
        });
        return { __sfc: true, headers, formatDate, feedId, page, perPage, sortBy, sortDesc, queryParams, fetchQueueStats, totalItems, areQueuesLoading, findQueuesFromStore, queues, store, pendingQueuesCount };
    }
});
